export default {"src":"/_next/static/media/why-1.e81966e7.svg","height":28,"width":25};